module.exports = __webpack_public_path__ + "img/img2.91561e75.png";